export const DEFAULT_BAREME_RULES = [
  { from_rank: 1, to_rank: 1, points: 20 },
  { from_rank: 2, to_rank: 2, points: 18 },
  { from_rank: 3, to_rank: 3, points: 16 },
  { from_rank: 4, to_rank: 4, points: 14 },
  { from_rank: 5, to_rank: 5, points: 13 },
  { from_rank: 6, to_rank: 6, points: 12 },
  { from_rank: 7, to_rank: 7, points: 11 },
  { from_rank: 8, to_rank: 9, points: 10 },
  { from_rank: 10, to_rank: 20, points: 10 },
  { from_rank: 21, to_rank: 40, points: 8 },
  { from_rank: 41, to_rank: 70, points: 5 },
  { from_rank: 71, to_rank: 100, points: 2 },
];

export const GAME_KIND_LABELS = {
  sudoku: 'Sudoku',
  mots_meles: 'Mots mêlés',
  memory: 'Memory',
  puzzle: 'Puzzle',
};

export const GAME_PLAY_HINTS = {
  sudoku: 'Cliquez une case puis un chiffre (ou un chiffre puis les cases). Une case juste se verrouille. Vous avez droit à 3 erreurs.',
  mots_meles: 'Cliquez sur la première lettre, gardez le bouton enfoncé et glissez jusqu’à la dernière lettre du mot (horizontal, vertical ou diagonal). Une même case peut servir à plusieurs mots : sa couleur ne change pas. Quand tous les mots sont trouvés, formez le mot bonus avec les lettres restantes.',
  memory: 'Cliquez deux cartes pour les retourner. Si elles sont identiques, la paire reste visible.',
  puzzle: 'Glissez chaque pièce sur sa case : elle ne se pose que si c’est la bonne, dans le bon sens. Clic droit pour tourner de 90°.',
  difference: 'Cliquez sur les différences entre les deux images.',
};

export const GAME_RANKING_HINTS = {
  sudoku: [
    'Temps réalisé',
    'Nombre d’erreurs',
    'Date et heure où la partie a été finie',
  ],
  mots_meles: [
    'Temps réalisé',
    'Date et heure où la partie a été finie',
  ],
  memory: [
    'Nombre de coups',
    'Temps réalisé',
    'Date et heure où la partie a été finie',
  ],
  puzzle: [
    'Temps réalisé',
    'Date et heure où le puzzle a été fini',
  ],
  difference: [
    'Temps réalisé',
    'Date et heure où la partie a été finie',
  ],
};

export const GAME_LEVELS = {
  sudoku: [
    { value: '4x4', label: '4×4' },
    { value: '6x6', label: '6×6' },
    { value: '9x9_easy', label: '9×9 facile' },
    { value: '9x9_medium', label: '9×9 moyen' },
    { value: '9x9_hard', label: '9×9 difficile' },
  ],
  mots_meles: [
    { value: 'petit', label: 'Petit' },
    { value: 'moyen', label: 'Moyen' },
    { value: 'grand', label: 'Grand' },
  ],
  memory: [
    { value: 'petit', label: 'Petit' },
    { value: 'moyen', label: 'Moyen' },
    { value: 'grand', label: 'Grand' },
  ],
  difference: [
    { value: '3', label: '3 écarts' },
    { value: '5', label: '5 écarts' },
    { value: '8', label: '8 écarts' },
  ],
  puzzle: [
    { value: '16', label: '16 pièces (4×4)' },
    { value: '25', label: '25 pièces (5×5)' },
    { value: '36', label: '36 pièces (6×6)' },
  ],
};

export function pointsForRank(rank, rules = DEFAULT_BAREME_RULES) {
  if (rank == null) return 0;
  const n = Number(rank);
  if (!Number.isFinite(n)) return 0;
  for (const rule of rules || []) {
    const lo = Number(rule.from_rank) || 0;
    const hi = Number(rule.to_rank) || lo;
    if (n >= lo && n <= hi) return Number(rule.points) || 0;
  }
  return 0;
}

export function formatElapsed(ms) {
  const total = Math.max(0, Math.floor((Number(ms) || 0) / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function formatFinishedAt(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function displayInitials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInput(local) {
  if (!local) return '';
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString();
}

export function defaultGameDates() {
  const now = new Date();
  const play = new Date(now.getTime() + 60 * 60 * 1000);
  return {
    published_at: toLocalInput(now.toISOString()),
    play_ends_at: toLocalInput(play.toISOString()),
  };
}

export function defaultSeasonDates() {
  const now = new Date();
  const end = new Date(now.getTime() + 90 * 24 * 60 * 60 * 1000);
  return {
    starts_at: toLocalInput(now.toISOString()),
    ends_at: toLocalInput(end.toISOString()),
  };
}
